import {
	FETCH_SCORES_COMPARISON_START,
	FETCH_SCORES_COMPARISON_SUCCESS,
	FETCH_SCORES_COMPARISON_ERROR,
} from '../actions/scores_comparison_actions';
import { ScoresComparisonStoreState } from '../types/models';

const initialState: ScoresComparisonStoreState = {
	scoresDetails: {},
	errors: [],
	loading: new Set(),
};

export default (oldState = initialState, action): ScoresComparisonStoreState => {
	Object.freeze(oldState);
	let newLoading;
	switch (action.type) {
		case FETCH_SCORES_COMPARISON_START:
			newLoading = new Set(oldState.loading);
			newLoading.add(action.sourcingEventId + '.' + action.supplierFacilityId);
			return {
				...oldState,
				loading: newLoading,
			};
		case FETCH_SCORES_COMPARISON_SUCCESS:
			let newScoresDetails = action.scoresDetails.reduce((acc, el) => {
				acc[`${el.sourcingEventId}.${el.supplierFacilityId}`] = el;
				return acc;
			}, {});
			const newScoresDetailIds = action.scoresDetails.map(
				(el) => el.sourcingEventId + '.' + el.supplierFacilityId
			);
			newLoading = new Set(oldState.loading);
			newScoresDetailIds.forEach((id) => {
				newLoading.delete(id);
			});
			return {
				...oldState,
				loading: newLoading,
				errors: [],
				scoresDetails: { ...oldState.scoresDetails, ...newScoresDetails },
			};
		case FETCH_SCORES_COMPARISON_ERROR:
			return {
				...oldState,
				loading: new Set([]),
				errors: [...oldState.errors, action.error],
			};
		default:
			return oldState;
	}
};
